<template>
	<div>
		<h1>TEST {{ pos }}</h1>
		<slider-view v-model="pos" :min="-25" :max="25" :step="1" :decimals="2" />
		<button-view @click="pos = 10">Test</button-view>

		<string-view />

		<slider-select-view v-model="temp" :min="-25" :max="25" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pos: 0,
				temp: 0
			};
		}
	}
</script>

<style lang="scss" scoped>

</style>